<template>
  <div>
    <a-page-header style="width: 105%; margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="rocket"/>
            <span>{{ $t('message.txtManagement.title1') }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="book"/>
            <span>{{ $t("message.blackAndWhiteList.blackAndWhiteList") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="book"/>
            <span>{{
                pageType === 'add' ?
                    $t("message.blackAndWhiteList.addList")
                    : pageType === 'edit' ? $t("message.blackAndWhiteList.editList") : $t("message.blackAndWhiteList.viewList")
              }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <a-card style="min-height: calc(100vh - 141px);">
      <a-row>
        <a-col :md="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 8 }" :xxl="{ span: 8 }">
          <a-form-model
              ref="addFormRef" :model="form" :labelCol="labelCol"
              :wrapperCol="wrapperCol" :rules="rules"
          >
            <!-- <a-form-model-item :label="$t('message.strategyManagement.BWMAddText')" prop="list_type">
              <a-radio-group :size="$globalSize" :disabled="onlyView||true" v-model="form.list_type">
                <a-radio :value="1"> {{ $t('message.strategyManagement.BWMTitle1') }}</a-radio>
                <a-radio :value="2"> {{ $t('message.strategyManagement.BWMTitle2') }}</a-radio>
              </a-radio-group>
            </a-form-model-item> -->
            <a-form-model-item :label="$t('message.memberCenter.phone')+' / '+$t('message.memberCenter.email')" prop="unSubscribeValue">
              <a-input :size="$globalSize" :disabled="onlyView || pageType==='edit'" v-model="form.unSubscribeValue"/>
            </a-form-model-item>
            <a-form-model-item
                  prop="valueType"
                  :label="$t('message.strategyManagement.BWMTableCol2')"
              >
                  <a-select :size="$globalSize"
                      :placeholder="$t('message.strategyManagement.BWMTableCol2')"
                      :options="valueTypeOptions()"
                      v-model="form.valueType"
                      allowClear
                      
                  ></a-select>
              </a-form-model-item>
            
          </a-form-model>
        </a-col>
      </a-row>
      <a-divider></a-divider>
      <a-row>
        <a-col :md="{ span: 24 }" :lg="{ span: 8 }" :xl="{ span: 8 }" :xxl="{ span: 8 }">
          <div class="flex grid-gap-16 " v-if="!onlyView">
            <a-button  :size="$globalSize"  class="form-submit-btn"  :loading="confirmLoading" @click="submit">{{
                $t('message.commonUsage.confirm')
              }}
            </a-button>
            <a-button  :size="$globalSize"  class="form-cancel-btn"  @click="$emit('close')">{{
                $t('message.commonUsage.cancel')
              }}
            </a-button>
          </div>

          <div class="flex grid-gap-16 " v-if="onlyView">
            <a-button  :size="$globalSize"  class="form-cancel-btn"  @click="$emit('close')">{{
                $t('message.commonUsage.back')
              }}
            </a-button>
          </div>
        </a-col>
      </a-row>
    </a-card>
    <a-modal
        title=""
        :visible="visible"
        :closable="false"
        :keyboard="false"
        :maskClosable="false"
        @cancel="handleCancel"
        :footer="null"
        centered
        :bodyStyle="{'padding-left':'24px'}"
    >
      <div v-if="result" class="confirm-modal-body w100 flex justify-content-center align-items-center">
        {{ $t('message.commonUsage.successfullySaved') }}
      </div>
      <div v-else class="confirm-modal-body w100 flex justify-content-center grid-gap-16 flex-direction-column mt24">
        <div>
          {{ resultMsg }}
        </div>
      </div>
      <div class="w100 flex justify-content-center grid-gap-16 mt24">
        <a-button  :size="$globalSize"  v-if="result" class="form-submit-btn"  @click="continueAdd">{{
            $t('message.blackAndWhiteList.title7')
          }}
        </a-button>
        <a-button  :size="$globalSize"  v-else class="form-submit-btn"  @click="visible = false">{{
            $t('message.commonUsage.edit')
          }}
        </a-button>
        <a-button  :size="$globalSize"  class="form-cancel-btn"  @click="$emit('close')">{{
            $t('message.commonUsage.back')
          }}
        </a-button>
      </div>
    </a-modal>

  </div>
</template>

<script>
import {formatDate} from "@/utils/formatUtils";
import MyPagination from "@/components/MyPagination";
import blackWhiteService from "@/interface/pages/blackWhiteList";
import moment from "moment";

export default {
  name: "addList",
  components: {
    MyPagination
  },
  props: {
    pageType: {
      type: String,
      default: 'add'
    },
    curItem: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    onlyView() {
      return this.pageType === 'view'
    }
  },
  mounted() {
    utils.languageChange(this, {labelCol: 4, wrapperCol: 18}, {labelCol: 8, wrapperCol: 16})
  },

  data() {
    let checkValType = (rule, value, callback) => {
      if (this.form.unSubscribeValue && !value) {
         callback(new Error(this.$t("message.pushStrategy.pleaseSelect")));
      }else{
        callback()
      }
    };
    return {
      result: true,
      resultMsg: '',
      visible: false,
      confirmLoading: false,
      form: {
        unSubscribeValue: undefined,
        valueType: undefined,
      },
      strategyList: [],
      rules: {
        unSubscribeValue: [
          {required: true, message:this.$t('message.memberCenter.phone')+' / '+this.$t('message.memberCenter.email'), trigger: 'change'}
        ],
        valueType: [
          {
            validator:checkValType,
            trigger: 'change',
          },
        ],
      },
      
      totalCount: 0,
      spinning: false,
      groupList: [],
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 4 : 8
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 18 : 16
      },
    }
  },
  watch: {
    pageType: {
      handler(val) {
        if (val === 'view' || val === 'edit') {
          console.log(this.curItem)
          this.form = {
            ...this.curItem,
            valueType: this.curItem.value_type,
            unSubscribeValue: this.curItem.unsubscribe_value,
          }
        }
      },
      immediate: true
    },
  },
  mounted() {
  },
  methods: {
    valueTypeOptions(){
      return [{
            label:this.$t("message.memberCenter.phoneNumber"),
            value:'phone'
          },{
            label:this.$t("message.memberCenter.email"),
            value:'email'
          }]
    },
    formatDate,
    submit() {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return false
        if (this.pageType === 'add') {
          this.addList()
        } else {
          this.editList()
        }
      })
    },
    continueAdd() {
      this.$refs.addFormRef.resetFields();
      this.visible = false;
    },
    handleCancel(e) {
      this.visible = false;
    },
    
    async addList() {
      this.confirmLoading = true
      const data = {
        ...this.form,
        userId:localStorage.getItem('userId'),
      }
      delete data.date
      const {data: res} = await blackWhiteService.addBlackWhiteList(this, {data})
      if (res.code == 200) {
        this.result = true
      } else {
        this.resultMsg = res.message
        this.result = false
      }
      this.visible = true
      this.confirmLoading = false
    },
    async editList() {
      this.confirmLoading = true
      const data = {
        ...this.form,
        userId:localStorage.getItem('userId'),

      }
      const {data: res} = await blackWhiteService.editBlackWhiteList(this, {data})
      if (res.code == 200) {
        this.$message.success(this.$t('message.commonUsage.successfullySaved'))
        setTimeout(() => {
          this.$emit('close')
        }, 500)
      } else {
        this.$message.error(res.msg)
      }
      this.confirmLoading = false
    },
  }
}
</script>

<style scoped lang="less">
.confirm-modal-body {
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.9);

}

.add-member-title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.9);
}

.form-sub-title {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.6);
}


::v-deep .ant-modal-title {
  text-align: left;
}

</style>